<template>
  <div>
    <b-modal
      id="modal-1"
      size="lg"
      v-model="exibirModal"
      :title="palestrante.pessoa"
      centered
      v-if="palestrante"
    >
      <p class="my-4"><img :src="palestrante.foto" :alt="`Foto de ${palestrante.pessoa}`" class="float-left mr-2 foto-palestrante-modal" /> {{ palestrante.bio }}</p>
      <template slot="modal-footer">
        <div class="float-left">
          <a
            v-if="palestrante.linkedin"
            :href="palestrante.linkedin"
            class="btn btn-link"
          >
            LinkedIn</a
          >
          <a
            v-if="palestrante.lattes"
            :href="palestrante.lattes"
            class="btn btn-link"
          >
            Lattes</a
          >
        </div>
        <div class="float-right">
          <button @click="exibirModal = !exibirModal" class="btn btn-warning">
            Fechar
          </button>
        </div>
      </template>
    </b-modal>
    <Secao titulo="palestrantes" id="palestrantes">
      <div class="palestrantes">
        <div
          class="palestrante"
          v-for="palestrante in palestrantesComFoto"
          @click="exibir(palestrante)"
          :key="palestrante.id"
        >
          <img :src="palestrante.foto" :alt="`Foto de ${palestrante.nome}`" />
          <div class="detalhes">
            <p class="nome">{{ palestrante.pessoa }}</p>
            <p class="descricao"><b>{{ palestrante.tipo }}:</b> {{ palestrante.nome }}</p>
          </div>
        </div>
      </div>
    </Secao>
  </div>
</template>

<script>
import Secao from "../layout/Secao.vue";
import PALESTRANTES from "@/assets/dados/palestrantes2.json";

export default {
  name: "App",
  components: {
    Secao,
  },

  data() {
    return {
      palestrantes: PALESTRANTES,
      palestrante: null,
      exibirModal: false,
    };
  },

  methods: {
    exibir(palestrante) {
      this.palestrante = palestrante;
      this.exibirModal = true;
    },
  },

  computed: {
    palestrantesComFoto(){
      return this.palestrantes.filter((x) => {
        return x.foto ? x : false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.codigo {
  color: var(--corPrincipal);
}
#palestrantes {
  background: linear-gradient(
    180deg,
    var(--bege) 50%,
    var(--corFundoIntercalado) 50%
  );
  /* 	padding-top: 0px;
	padding-bottom: 0px; */
}
.palestrantes {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  .palestrante {
    width: 100%;
    height: 300px;
    flex: 1 1 200px;
    overflow: hidden;
    border-radius: 10px;
    position: relative;
    box-shadow: var(--sombra);
    &:hover {
      transition: 0.2s;
      border: 2px solid #ddd;
      cursor: pointer;
    }
    img {
      min-width: 100%;
      height: 100%;
    }
    .detalhes {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100px;
      background: linear-gradient(
        137.43deg,
        var(--begeCor) 1%,
        rgba(15, 74, 92, 0.12) 100%
      );
      backdrop-filter: blur(23.2936px);
      padding: 15px;
      p {
        margin: 0;
      }
      .nome {
        font-family: "JetBrains Mono";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 108.5%;
        color: var(--corFundoIntercalado);
      }
      .descricao {
        font-family: "JetBrains Mono";
        font-weight: 300;
        font-size: 14px;
        line-height: 90%;
        color: #000;
      }
    }
  }
}
.foto-palestrante-modal{
	max-width: 300px;
	float: left;
	border-radius: 20px;
	margin-right: 1rem;
}
@media screen and (max-width: 900px) {
  .palestrantes {
    grid-template-columns: repeat(1, 1fr);
    .palestrante {
      flex: 1 1 50%;
    }
  }
}
@media screen and (max-width: 600px) {
  .palestrantes {
    .palestrante {
      flex: 1 1 100%;
    }
  }
}
</style>